import { render, staticRenderFns } from "./PeriodBar.vue?vue&type=template&id=1472a54c&scoped=true"
import script from "./PeriodBar.vue?vue&type=script&lang=js"
export * from "./PeriodBar.vue?vue&type=script&lang=js"
import style0 from "./PeriodBar.vue?vue&type=style&index=0&id=1472a54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472a54c",
  null
  
)

export default component.exports